import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { Field, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { CircularProgress, Grid, IconButton, Paper, Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CustomInputField from 'ui-components/formik/CustomInputField';
import ModalComponent from 'ui-components/ModalComponent';
import { Primary, Secondary } from 'ui-components/Buttons';
import * as Yup from "yup";

const useStyles = makeStyles({
    customInput: {
        '& .MuiInputBase-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '12px',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
            },
            '&.Mui-focused': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.5)',
            }
        },
        '& .MuiInputLabel-root': {
            color: '#666',
            fontSize: '0.9rem',
            fontWeight: 500,
        },
        '& .MuiInputBase-input': {
            padding: '16px 18px',
            fontSize: '1rem',
            '&::placeholder': {
                color: '#999',
                opacity: 1,
            }
        }
    },
    gradientPaper: {
        // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        // background: theme.palette.customColors.b300,
        // background: `linear-gradient(135deg, ${theme.palette.customColors.b300} 0%, #764ba2 100%)`,
                // background: `linear-gradient(135deg, rgb(120, 82, 248), rgb(132, 174, 246))`,
        borderRadius: '20px !important',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        backgroundImage:
      'linear-gradient(#fffaf5, #fffaf5), linear-gradient(135deg, #0046ff, #cc5adf)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    border: '2px solid transparent',
    },
    contentSection: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '16px',
        margin: '0 1rem 1rem 1rem',
        padding: '1.5rem',
        backdropFilter: 'blur(10px)',
        border: '1px solid #EAECF0',
    },
    closeButton: {
        position: 'absolute',
        top: '16px',
        right: '16px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        color: 'white',
        padding: '8px',
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
        }
    },
    sparkleIcon: {
        position: 'absolute',
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: '1.5rem',
    }
});

const EnterPromoCodePopup = ({ open, selectedPlan = null, handleClose, handleSubmission, handleDirectPayment, isSubmitting = false, isVerifyingCode = false }) => {
    const classes = useStyles();

    const [continueLoading, setContinueLoading] = React.useState(false);

    const formik = useFormik({
        initialValues: {
            offer_code: '',
            option: null
        },
        validationSchema: Yup.object({
            offer_code: Yup.string().required("Please enter a offer code"),
        }),
        validateOnBlur: false,
        validateOnChange: false,
        validateOnMount: false,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm, setFieldValue }) => {
            await handleSubmission({ offer_code: values?.offer_code?.trim() })
        },
    });

    return (
        <ModalComponent open={open} onClose={handleClose} style={{ maxWidth: "500px", width: "calc(100% - 1rem)"}}>
            <Paper className={classes.gradientPaper}>
                {/* Decorative sparkles */}
                {/* <Box className={classes.sparkleIcon} sx={{ top: '20px', left: '20px' }}>✨</Box>
                <Box className={classes.sparkleIcon} sx={{ top: '40px', right: '60px' }}>⭐</Box>
                <Box className={classes.sparkleIcon} sx={{ bottom: '120px', left: '30px' }}>✨</Box>
                <Box className={classes.sparkleIcon} sx={{ bottom: '80px', right: '40px' }}>⭐</Box> */}

                {/* Close button */}
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon width={24} height={24} />
                </IconButton>

                {/* Header section with gradient background */}
                <Box sx={{ padding: '2.5rem 1.5rem 1rem 1.5rem', textAlign: 'center' }}>
                    {/* <Box sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        background: "white",
                        // backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        marginBottom: '1rem',
                        backdropFilter: 'blur(10px)'
                    }}> */}
                    {/* <Box sx={{
                            width: '100%',
                            height: '24px',
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.8rem'
                        }}>
                            <img src='https://backrr.com/assets/public_home_logo_transparent.svg' style={{ width: "100%", maxWidth: "6rem", mixBlendMode: "multiply" }} />
                        </Box> */}
                    {/* <Typography sx={{ color: 'white', fontSize: '1rem', fontWeight: 600 }}>
                            Backrr
                        </Typography> */}
                    {/* <Typography sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem' }}>
                            Special Offer ✨
                        </Typography> */}
                    {/* </Box> */}

                    <Typography sx={{
                        color: 'black',
                        fontSize: '1.9rem',
                        fontWeight: 700,
                        marginBottom: '1.5rem',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}>
                        Got an Offer Code?
                    </Typography>

                    <Typography sx={{
                        color: 'rgba(0, 0, 0, 0.9)',
                        fontSize: '0.95rem',
                        lineHeight: 1.5,
                        maxWidth: '300px',
                        margin: '0 auto',
                        marginBottom: "0rem"
                    }}>
                        Enter your offer code below to unlock exclusive discounts and special offers!
                        {/* ✨ */}
                    </Typography>
                </Box>

                {/* Form section with white background */}
                <Box className={classes.contentSection}>
                    <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit} onKeyDown={(e) => {
                            if ((e.key === "Enter" && !e.shiftKey)) {
                                e.preventDefault();
                            }
                        }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography sx={{
                                        fontSize: '1rem',
                                        fontWeight: 600,
                                        color: '#333',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Offer Code
                                    </Typography>
                                    <CustomInputField
                                        name="offer_code"
                                        placeholder="e.g. FLAT10"
                                        value={formik?.values?.offer_code}
                                        sx={{ marginBottom: 0 }}
                                        onChange={(e) => {
                                            const inputValue = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            formik.setFieldValue('offer_code', inputValue);
                                        }}
                                    // className={classes.customInput}
                                    // InputProps={{
                                    //     endAdornment: (
                                    //         <Box sx={{ color: '#667eea', fontSize: '1.2rem' }}>
                                    //             🎁
                                    //         </Box>
                                    //     )
                                    // }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Primary
                                        type="submit"
                                        fullWidth
                                        disabled={isSubmitting || isVerifyingCode || continueLoading}
                                        sx={{ padding: '0.875rem 1.5rem', fontSize: '1rem' }}>
                                        {(isSubmitting || isVerifyingCode) && !continueLoading ? <CircularProgress size={"1.5rem"} sx={{ color: 'white' }} /> : "Redeem Code"}
                                    </Primary>
                                </Grid>

                                <Grid item xs={12}>
                                    <Secondary
                                        type="button"
                                        fullWidth
                                        disabled={isSubmitting || isVerifyingCode || continueLoading}
                                        sx={{ padding: '0.875rem 1.5rem', fontSize: '1rem' }}
                                        onClick={async () => {
                                            setContinueLoading(true);
                                            try {
                                                await handleDirectPayment({ ...selectedPlan });
                                            } finally {
                                                setContinueLoading(false);
                                            }
                                        }}>
                                        {continueLoading ? <CircularProgress size={"1.5rem"} /> : "Continue Without Code"}
                                    </Secondary>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography sx={{
                                        textAlign: 'center',
                                        color: '#666',
                                        fontSize: '0.85rem',
                                        lineHeight: 1.4,
                                        marginTop: '0.5rem'
                                    }}>
                                        Don't have a code? No worries! You can still continue and explore our amazing features.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                    </FormikProvider>
                </Box>
            </Paper>
        </ModalComponent>
    );
};

export default EnterPromoCodePopup;